import { useQuery } from 'react-query';
import {
  ProductWithQuality,
  RiskObjectError,
} from '../../../../../../types/Quotes';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import { getProductKey } from '../../../services/offersService';
import {
  addProductKeysToId,
  addQuoteIdsToUrl,
} from '../../../store/redux/slices/offersSlice';
import store from '../../../store/redux/store';

interface Params {
  sessionId: string;
  insuranceType: string;
  lang?: string;
}

export interface ProductInfoAndContent {
  insurance_company: string;
  insurance_type: string;
  insurance_name: string;
  insurance_content: InsuranceContent;
  guarantee_content: GuaranteeContent[];
  forbidden_combinations: string[];
  mandatory_guarantees: string[];
  guarantee_requirements: {
    [guarantee: string]: string[];
  };
}

export interface InsuranceContent {
  id: string;
  type: string;
  name: string;
  ipid: string;
  terms: string;
}

export interface GuaranteeContent {
  id: string;
  key: string;
  name: string;
  description: string;
}

export interface ProductsResponse {
  items: ProductWithQuality[];
  risk_object_errors: RiskObjectError[];
  info_and_content: ProductInfoAndContent[];
}

export const getProducts = async ({
  sessionId,
  insuranceType,
  lang,
}: Params) => {
  const { data, isError } = await wgApi.post<ProductsResponse>(
    `/v1/api/conversations/${sessionId}/possible-quote-combinations`,
    {
      insurance_type: insuranceType,
    },
    {
      query: {
        lang,
      },
    },
  );
  if (isError) throw new Error();
  return data;
};

export const getUseProductsQKey = (params: Params) => [
  'sales-conversation',
  'products',
  params,
];

export const useProducts = (params: Params) => {
  return useQuery(getUseProductsQKey(params), () => getProducts(params), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    onSuccess: (data) => {
      onProductSuccess(data);
    },
  });
};

// TODO: Enable this to be able to retrieve prices
export const onProductSuccess = (data: ProductsResponse): void => {
  // Set HASH map
  store.dispatch(
    addQuoteIdsToUrl(
      Object.assign(
        {},
        ...data.items.map(
          ({ hash_id, self }: { hash_id: string; self: string }) => ({
            [hash_id]: self.replace('/quotes/v1', '/quotes/v2'),
          }),
        ),
      ),
    ),
  );
  store.dispatch(
    addProductKeysToId(
      Object.assign(
        {},
        ...data.items.map((offer) => ({
          [offer.hash_id]: getProductKey(offer),
        })),
      ),
    ),
  );
};
